const PitchMechanics = {
    'WindUp': { key: 'WU', name: 'Wind Up' },
    'Stretch': { key: 'ST', name: 'Stretch' },
    'Unidentified': { key: 'UI', name: 'Unidentified' }
};

export default PitchMechanics;